import React from 'react';

import { cn } from '@/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => (
	<textarea
		className={cn(
			'flex min-h-[80px] w-full rounded-lg border border-brand-gray-4 bg-brand-gray-6 px-3 py-[10px] font-sans text-base ring-offset-white placeholder:text-brand-gray-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
			className
		)}
		ref={ref}
		{...props}
	/>
));
Textarea.displayName = 'Textarea';

export { Textarea };
